
    <div *ngIf="showPopover" class="main-container">
      <div (click)="copyToClipboard()" class="container">
        <p *ngIf="!showCopiedText" class="text">{{text}}</p>
        <p *ngIf="showCopiedText" class="text">{{copiedText}}</p>
        <div class="vertical-line"></div>
        <i  class="fa fa-copy copy-icon"></i>
      </div>
    </div>